import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/workspaces/page';

export const Route = createFileRoute('/_app/settings/workspaces/')({
  component: Page,
});
